import React, { memo } from 'react';

import { Box, Typography } from '@mui/material';
import PropTypes from 'prop-types';

import TeamChatPresenceIndicator from '../TeamChatPresenceIndicator';

import { rootStyles, titleGroupStyles } from './TeamChatHeader.styles';
import { formatMemberCountLabel, formatOnlineCountLabel } from './TeamChatHeader.utils';

const TeamChatHeader = memo(
  ({
    title,
    memberCount = null,
    endSlot = null,
    isHidden = false,
    onlineCount = null,
    totalCount = null,
  }) => {
    if (isHidden) {
      return null;
    }

    const memberCountLabel = formatMemberCountLabel(memberCount);
    const onlineCountLabel = formatOnlineCountLabel({ onlineCount, totalCount });

    return (
      <Box sx={rootStyles}>
        <Box sx={titleGroupStyles}>
          <Typography variant="medium16">{title}</Typography>
          {!!memberCountLabel && <Typography variant="regular12">{memberCountLabel}</Typography>}
          {!!onlineCountLabel && (
            <>
              <TeamChatPresenceIndicator isOnline={onlineCount > 0} />
              <Typography variant="regular12">{onlineCountLabel}</Typography>
            </>
          )}
        </Box>
        {endSlot}
      </Box>
    );
  },
);
TeamChatHeader.propTypes = {
  title: PropTypes.string.isRequired,
  memberCount: PropTypes.number,
  endSlot: PropTypes.node,
  isHidden: PropTypes.bool,
  onlineCount: PropTypes.number,
  totalCount: PropTypes.number,
};

export default TeamChatHeader;
